import React, { useState } from "react";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { Commas } from "../../../Common/AllDateTimeReleventFormate";
import DisplayFileProper from "../../../Common/FilesRelevent/DisplayFileProper";
import ConfirmModal from "../../../Common/ConfirmModal";

export default function PackagedServiceList({ listing, update, deleteee, checksold = 0 }) {
  const [selectedId, setSelectedId] = useState(null);

  return (
    <div>
      <div className="row add-wrapper">
        {Array.isArray(listing) &&
          listing?.map((item, index) => (
            <div className="col-md-4" key={item?.id || index}>
              <div className="add-education-wrapper1">
                <div className="edu-img">
                  <DisplayFileProper
                    item={{
                      file:
                        Array.isArray(item?.files) && item?.files[0]?.file,
                    }}
                    className="w-100"
                  />
                </div>

                <div className="add-button-education">
                  {
                    (checksold && item?.status != 1) ?
                    <p
                      className="post-applied  post-ap your-postbtn"
                      style={{ background: "#DE311ECC" }}
                    >
                      Sold out
                    </p>
                    :""
                  }
                  <button
                    onClick={() => {
                      setSelectedId(item?.id);
                    }}
                  >
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/contestdetails/delete-icon.svg`}
                      alt="delete"
                    />
                  </button>

                  <button
                    onClick={() => {
                      update(item?.id);
                    }}
                  >
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                      alt="edit"
                    />
                  </button>
                </div>

                <h6>{item?.title}</h6>
                <h2>
                  {item?.rental_only == 0
                    ? `SAR ${Commas(item?.price_interpreter)}`
                    : `SAR ${Commas(item?.price)}`}
                </h2>
              </div>

              <ConfirmModal
                isOpen={selectedId === item?.id}
                toggle={() => setSelectedId(null)}
                title="Confirm Delete"
                message="Do you want to delete this item?"
                onConfirm={() => {
                  deleteee(item?.id);
                  setSelectedId(null);
                }}
              />
            </div>
          ))}
      </div>
    </div>
  );
}
